import { Checkbox, Grid } from '@mantine/core';
import FormHeading from 'apps/Projects/SamplePlans/FormInputs/FormHeading';

import { STRATIFY } from 'constants/projects';

import InputAndLabelGridRow from 'common/Components/InputAndLabelGridRow';

import { useProjectsTranslations } from '../hooks';
import { useSamplePlanFormContext } from '../samplePlanFormContextV2';

const StratificationDetails = () => {
  const translations = useProjectsTranslations();
  const samplePlanForm = useSamplePlanFormContext();

  const formValues = samplePlanForm.getValues();
  const isStratify = formValues.method === STRATIFY;

  return (
    <>
      <FormHeading text={translations.stratification} mb="xs" />
      <Grid>
        <InputAndLabelGridRow
          elemId="stratify-checkbox"
          label={`${translations.stratify}?`}
          span={5}
          input={
            <Checkbox
              id="stratify-checkbox"
              {...samplePlanForm.getInputProps('method', { type: 'checkbox' })}
              checked={isStratify}
              onChange={() => samplePlanForm.setFieldValue('method', isStratify ? null : STRATIFY)}
            />
          }
        />
      </Grid>
    </>
  );
};

export default StratificationDetails;
